<template>
  <Bar :data="chartData" :options="chartOptions" />
</template>

<script>
import { Bar } from 'vue-chartjs'
import {
  Chart as ChartJS,
  BarElement,
  CategoryScale,
  LinearScale,
  Tooltip,
} from 'chart.js'

ChartJS.register(BarElement, CategoryScale, LinearScale, Tooltip)

const VALUE_LABELS = {
  'self-direction': 'Autodirecționare',
  'power':          'Putere',
  'universalism':   'Universalism',
  'achievement':    'Realizare',
  'security':       'Securitate',
  'stimulation':    'Stimulare',
  'conformity':     'Conformitate',
  'tradition':      'Tradiție',
  'hedonism':       'Hedonism',
  'benevolence':    'Bunăvoință',
}

export default {
  name: 'PvqChart',
  components: { Bar },

  props: {
    valueRanking: {
      type: Array,
      required: true,
    },
  },

  computed: {
    chartData() {
      // Sort highest → lowest (already ranked, but make explicit)
      const sorted = [...this.valueRanking].sort((a, b) => b.score - a.score)

      return {
        labels: sorted.map(r => VALUE_LABELS[r.dimension] ?? r.dimension),
        datasets: [{
          data: sorted.map(r => r.score),
          backgroundColor: sorted.map(r =>
            r.score >= 0
              ? 'rgba(76, 175, 80, 0.75)'   // green for positive
              : 'rgba(158, 158, 158, 0.4)'  // grey for negative
          ),
          borderColor: sorted.map(r =>
            r.score >= 0
              ? 'rgba(56, 142, 60, 1)'
              : 'rgba(117, 117, 117, 0.6)'
          ),
          borderWidth: 1,
          borderRadius: 3,
        }],
      }
    },

    chartOptions() {
      return {
        indexAxis: 'y',           // horizontal bars
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          legend: { display: false },
          tooltip: {
            callbacks: {
              label: ctx => {
                const v = ctx.parsed.x
                return ` ${v >= 0 ? '+' : ''}${v.toFixed(2)}`
              },
            },
          },
        },
        scales: {
          x: {
            grid: { color: ctx => ctx.tick.value === 0 ? '#888' : 'rgba(0,0,0,0.05)' },
            ticks: { callback: v => (v >= 0 ? '+' : '') + v.toFixed(1) },
          },
          y: {
            ticks: { font: { size: 12 } },
          },
        },
      }
    },
  },
}
</script>
